import { render } from "./z-panginate.vue?vue&type=template&id=ab40a02e&lang=pug"
import script from "./z-panginate.vue?vue&type=script&setup=true&lang=js"
export * from "./z-panginate.vue?vue&type=script&setup=true&lang=js"

import "./z-panginate.vue?vue&type=style&index=0&id=ab40a02e&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__